import { Box } from "@mui/material";

import type { PageTemplateProps } from "./Page.template.types";
import * as styles from "./Page.template.styles";

export type { PageTemplateProps } from "./Page.template.types";

export function PageTemplate({ children, maxWidth = 1200 }: PageTemplateProps) {
  return (
    <Box sx={styles.main}>
      <Box sx={styles.content(maxWidth)}>{children}</Box>
    </Box>
  );
}
